import i18n from "i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from "react-i18next";

const resources = {
    en: {
        translation: {
            "edit_profile": "Edit Profile",
            "profile": "Profile",
            "profiles": "Profiles",
            "skills": "Skills",
            "work_experience": "Work Experience",
            "education": "Education",
            "personal_information": "Personal Information",
            "firstname": "First Name",
            "lastname": "Last Name",
            "email": "Email",
            "save": "Save",
            "cancel": "Cancel",
            "language": "Language",
            "job_title": "Job Title",
            "company": "Company",
            "location": "Location",
            "start_date": "Start Date",
            "end_date": "End Date",
            "description": "Description",
            "add": "Add",
            "edit": "Edit",
            "delete": "Delete",
            "add_work_experience": "Add Work Experience",
            "add_education": "Add Education",
            "resume": "Resume",
            "job_posts": "Job Posts",
            "cover_letter": "Cover Letter",
            "job_analytics": "Job Analytics",
            "technical_questions": "Technical Questions",
            "behavioural_questions": "Behavioural Questions",
            "create_resume": "Create Resume"
        }
    },
    tr: {
        translation: {
            "edit_profile": "Profilimi Düzenle",
            "profile": "Profil",
            "profiles": "Profiller",
            "skills": "Yetenekler",
            "work_experience": "İş Deneyimi",
            "education": "Eğitim",
            "personal_information": "Kullanıcı Bilgileri",
            "firstname": "Ad",
            "lastname": "Soyad",
            "email": "E-posta",
            "save": "Kaydet",
            "cancel": "İptal",
            "language": "Dil",
            "job_title": "İş Unvanı",
            "company": "Firma",
            "location": "Lokasyon",
            "start_date": "Başlama Tarihi",
            "end_date": "Bitiş Tarihi",
            "description": "Açıklama",
            "add": "Ekle",
            "edit": "Düzenle",
            "delete": "Sil",
            "add_work_experience": "İş Deneyimi Ekle",
            "add_education": "Eğitim Ekle",
            "resume": "Özgeçmis",
            "job_posts": "İş İlanları",
            "cover_letter": "Ön Yazı",
            "job_analytics": "İş İlan Analizi",
            "technical_questions": "Teknik Sorular",
            "behavioural_questions": "Davranışsal Sorular",
            "create_resume": "Özgeçmis Oluştur"
        }
    }
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: "en",
        supportedLngs: ["en", "tr"],
        interpolation: {
            escapeValue: false
        }
    });

export default i18n;